import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token fallback if present
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("session_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export default api;
